export enum StaffAvailabilityType {
    "available" = "available",
    "unavailable" = "unavailable",
    "trip" = "trip"
}

export interface StaffTripAvailability {
    id: number,
    staffId: number,
    startDate: Date,
    endDate: Date,
    type: StaffAvailabilityType
}

export interface StandardTripWeek {
    id: number,
    startDate: Date,
    nextWeekStartDate: Date,
    season: string,
    weekNumber: number,
    year: number
}

export interface TripStaffingView extends TripStaffingFields {
    id: number,
    subtripId: string,
    groupingId?: string,
    custId: number,
    tripDate: Date,
    endDate: Date,
    startingWeek: Date,
    endingWeek: Date,
    startingWeekNumber: number,
    endingWeekNumber: number,
    note?: string,
    staffingComplete?: number,
    staffingCompleteBy?: number,
    staffingCompleteDate?: Date,
    staffingCompleteAttendees?: number,
    noteEditedBy?: number,
    noteEditedDate?: Date,
    communities: {id: string, name: string}[]

}

export interface TripStaffingFields {
    tlId: number,
    tlConfirmed: number,
    siteLeaderId?: number,
    siteLeaderConfirmed?: number
    atl1: number,
    atl1Confirmed: number,
    atl2: number,
    atl2Confirmed: number,
    atl3: number,
    atl3Confirmed: number,
    atl4: number,
    atl4Confirmed: number,
    atl5: number,
    atl5Confirmed: number,
    atl6: number,
    atl6Confirmed: number,
    atl7: number,
    atl7Confirmed: number,
    atl8: number,
    atl8Confirmed: number,
    atl9: number,
    atl9Confirmed: number,
    atl10: number,
    atl10Confirmed: number,
    atl11: number,
    atl11Confirmed: number,
    atl12: number,
    atl12Confirmed: number,
    atl13: number,
    atl13Confirmed: number,
    atl14: number,
    atl14Confirmed: number,
    atl15: number,
    atl15Confirmed: number,
    atl16: number,
    atl16Confirmed: number
}

export type AtlKeys = Pick<TripStaffingView, "atl1" | "atl2" | "atl3" | "atl4" | "atl5" | "atl6" | "atl7" | "atl8" | "atl9" | "atl10" | "atl11" | "atl12" | "atl13" | "atl14" | "atl15" | "atl16">

export interface TripStaffingDetail {
    id: number,
    note: string,
    staffingComplete: number
    staffingCompleteBy: number,
    staffingCompleteDate: Date,
    staffingCompleteAttendees?: number,
    noteEditedBy: number,
    noteEditedDate: Date
}

export interface StaffHistoryTrip {
    id: number,
    locId?: string,
    attendees?: string,
    tripDate?: Date
}